module.exports = __webpack_public_path__ + "static/img/10.0bf8a0a0.png";